var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconeTubeTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 17.0002C21.1046 17.0002 22 16.0674 22 14.9168C22 14.1969 21.217 13.2361 20.6309 12.6176C20.2839 12.2515 19.7161 12.2515 19.3691 12.6176C18.783 13.2361 18 14.1969 18 14.9168C18 16.0674 18.8954 17.0002 20 17.0002Z",
    fill: "#5963f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.278 10.5677L17.7828 7.97036L9.37268 3.14355L2.65093 14.7458C1.31093 17.0587 2.10615 20.0163 4.42709 21.3517C6.74803 22.687 9.7158 21.8946 11.0558 19.5816L12.1751 17.6497L16.278 10.5677Z",
    fill: "#5963f3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.2939 1.35449C8.93733 1.14371 8.47739 1.26188 8.2666 1.61845C8.05581 1.97502 8.17399 2.43495 8.53056 2.64574L9.36645 3.13989L9.37231 3.14332L17.7824 7.97013L18.6261 8.45434C18.9853 8.66053 19.4437 8.53644 19.6499 8.17719C19.8561 7.81794 19.732 7.35957 19.3727 7.15338L10.1256 1.84619L9.2939 1.35449Z",
    fill: "#5963f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9271 16.3515L12.9253 16.3505L10.3126 14.8472C9.9536 14.6407 9.49509 14.7643 9.28852 15.1233C9.08195 15.4823 9.20555 15.9408 9.56457 16.1474L12.1752 17.6495L12.9271 16.3515Z",
    fill: "#5963f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5647 13.525L14.5629 13.5239L10.3599 11.1057C10.0009 10.8992 9.54239 11.0227 9.33582 11.3818C9.12925 11.7408 9.25284 12.1993 9.61187 12.4059L13.8128 14.8229L14.5647 13.525Z",
    fill: "#5963f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2763 10.5665L13.7183 9.09468C13.3592 8.88811 12.9007 9.0117 12.6941 9.37073C12.4876 9.72976 12.6112 10.1883 12.9702 10.3948L15.5262 11.8654L16.2763 10.5665Z",
    fill: "#5963f3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeTubeTest);
export default __webpack_public_path__ + "static/media/IconeTubeTest.efe5c65675c74e5d3a6ea166b7138ec8.svg";
export { ForwardRef as ReactComponent };